module.exports = __webpack_public_path__ + "images/pages/lp/estimate_process_2_fe82e10cf0fb0a6e3689ca3e2e583e3a.png";